import * as dateish from 'js/dateish';
import * as d3 from 'd3';

export type Barchart = {
  dataRows: BarchartRow[]
  numSpecies: number
  numTaxa: number
}

// Enough so I can delete the data I don't care about
export type BarchartRow = {
  taxon?: {
    displayName: string,
    commonName: string,
    sciName: string,
    speciesCode: string,
    category: string, // TODO species, spuh, ...
    reportAsSpeciesCode: "empgoo",
    reportAsCategory: string // TODO species, spuh, ...
    showSpeciesPageLink: boolean,
  }
  exoticCategory?: ExoticCategory
  values: number[]
  prettyValues?: string[]
  values_N?: number[]
  buckets?: number[]
  speciesCode: string
  name?: string
}

export type ExoticCategory =
  | "N" // naturalized
  | "P" // provisional
  | "X" // escapee/exotic

export function getBarchartValue(row: BarchartRow, date: dateish.Any): number {
  return date.kind === 'doy'
    ? getBarchartValueDoY(row, date.value)
    : getBarchartValueMoY(row, date.value);
}

function getWeekishIndex(doy: dateish.DoY): number {
  const [ month, day ] = doy.split("-");
  return (parseInt(month)-1) * 4 + Math.floor((parseInt(day)-1) / 7);
}

export function getBarchartValueDoY(row: BarchartRow, doy: dateish.DoY): number {
  return row.values[getWeekishIndex(doy)];
}

export function getBarchartValueMoY(row: BarchartRow, moy: dateish.MoY): number {
  // TODO: Do a normalized average with values_N as
  const doms: dateish.DoM[] = ['01','08','15','22'];
  return d3.mean(doms.map(dom => getBarchartValueDoY(row, dateish.toDoY(moy, dom))))!;
}